<template>
  <transition name="slide-fade">
    <div class="toast" v-show="visible">
      <div class="wrapper">{{ message }}</div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'toast',
  data () {
    return {
      message: '', // 消息文字
      duration: 3000, // 显示时长，毫秒
      closed: false, // 用来判断消息框是否关闭
      timer: null, // 计时器
      visible: false // 是否显示
    }
  },
  mounted () {
    this.startTimer()
  },
  watch: {
    closed (newVal) {
      if (newVal) {
        this.visible = false
        this.destroyElement()
      }
    }
  },
  methods: {
    destroyElement () {
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
    },
    startTimer () {
      this.timer = setTimeout(() => {
        if (!this.closed) {
          this.closed = true
          clearTimeout(this.timer)
        }
      }, this.duration)
    }
  }
}
</script>

<style scoped>
.toast{
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%,-50%);
  border-radius: 10px;
  border: 2px solid #8d1c10;
}

.toast .wrapper{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  min-width: 300px;
  max-width: 750px;
  min-height: 60px;
  font-size: 24px;
  text-align: center;
  padding: 8px 20px; 
  background-color: #8d1c10;
  color: #ffeec3;
  letter-spacing: 3px; 
  border: 1px solid #9f3a31;
}
</style>